<template>
    <div class="tw-flex tw-flex-col">
        <div class="tw-w-full">
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-w-full tw-items-center">
                    <button
                        @click="selectedPackageType = 'oneTime'"
                        :class="`tw-relative tw-min-w-0 tw-flex-1 tw-py-4 tw-text-center tw-text-sm tw-font-medium tw-font-medium ${
                            selectedPackageType === 'oneTime'
                                ? 'tw-text-black night:tw-text-white'
                                : 'tw-text-gray-300 night:tw-text-gray-400'
                        }`"
                    >
                        {{ $t('message.packages') }}
                        <div
                            v-if="selectedPackageType === 'oneTime'"
                            class="tw-absolute tw-bottom-0 tw-left-0 tw-h-0.5 tw-w-full tw-bg-black night:tw-bg-white"
                        ></div>
                    </button>
                    <button
                        @click="selectedPackageType = 'recurring'"
                        :class="`tw-relative tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-center tw-gap-1 tw-py-4 tw-text-center tw-text-sm tw-font-medium ${
                            selectedPackageType === 'recurring'
                                ? 'tw-text-black night:tw-text-white'
                                : 'tw-text-gray-300 night:tw-text-gray-400'
                        }`"
                    >
                        <span class="tw-truncate">{{
                            $t('message.packagesRecurring')
                        }}</span>
                        <v-tooltip v-model="tooltip" top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click.stop="tooltip = !tooltip"
                                    small
                                    class="tw-shrink-0"
                                >
                                    mdi-help-circle-outline
                                </v-icon>
                            </template>
                            <span>{{
                                $t('message.packagesRecurringDescription')
                            }}</span>
                        </v-tooltip>
                        <div
                            v-if="selectedPackageType === 'recurring'"
                            class="tw-absolute tw-bottom-0 tw-left-0 tw-h-0.5 tw-w-full tw-bg-black night:tw-bg-white"
                        ></div>
                    </button>
                </div>
                <div class="tw-h-px tw-w-full tw-bg-gray-200 night:tw-bg-gray-700"></div>
            </div>
        </div>

        <div class="tw-mt-4">
            <div
                v-if="selectedPackageType === 'oneTime'"
                class="tw-flex tw-flex-col"
            >
                <div
                    v-if="packages.length === 0"
                    class="tw-text-gray-600 night:tw-text-gray-400"
                >
                    {{ $t('message.packagesNotAvailable') }}
                </div>
                <PackageTab
                    key="oneTimeTab"
                    type="one-time"
                    :isBuyable="isBuyable"
                    :categories="categories"
                    :packages="packages"
                    @sharePackage="sharePackage"
                    :familyAccounts="familyAccounts"
                />
            </div>

            <div v-else class="tw-flex tw-flex-col">
                <div
                    v-if="recurringPackages.length === 0"
                    class="tw-text-gray-600 night:tw-text-gray-400"
                >
                    {{ $t('message.packagesRecurringNotAvailable') }}
                </div>
                <PackageTab
                    key="recurringTab"
                    type="recurring"
                    :isBuyable="isBuyable"
                    :categories="categories"
                    :packages="recurringPackages"
                    :familyAccounts="familyAccounts"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { STUDIO_MODULE_NAME } from '@/store/moduleNames'
import PackageTab from '@/components/packages/PackageTab'
import { getPackageCategories } from '@/util/cloudFunctions/packagesFunctions'

export default {
    components: {
        PackageTab,
    },
    props: {
        packages: Array,
        recurringPackages: Array,
        isBuyable: {
            type: Boolean,
            default: true,
        },
        familyAccounts: Array,
    },
    data() {
        return {
            selectedPackageType: 'oneTime',
            tooltip: false,
            categories: [],
        }
    },
    computed: {
        ...mapGetters({
            studio: `${STUDIO_MODULE_NAME}/getStudio`,
        }),
    },
    methods: {
        sharePackage() {
            this.$emit('sharePackage')
        },
        cancelStatus(isSuccess, error) {
            this.$emit('cancelStatus', isSuccess, error)
        },
    },
    async created() {
        this.categories = await getPackageCategories(this.studio.id)
    },
}
</script>

<style scoped>
.v-tooltip {
    display: inline-flex;
}
</style>
